<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <RadioGroup :options="radioData" @radioChange="radioChange" />

    <div class="dataShow">
      <div class="wrap">
        <div class="item" v-for="(n, i) in showData" :key="i">
          <div class="num">{{ n.value }}</div>
          <div class="text">{{ n.label }}</div>
        </div>
      </div>
    </div>

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"></SearchField>

    <Table ref="table" :tableHeight="tableHeight" :tableData="tableData" :cols="cols" />
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      tableHeight: 450,
      baseUrl: 'contract',
      breadcrumb: [
        { name: "财务管理", path: `/finance/receivableAccounts` },
        { name: "应收/应付账款", path: `/finance/receivableAccounts` },
        { name: "数据统计" },
      ],
      radioData: [
        { label: "自有车辆", value: 1 },
        { label: "雇佣车辆", value: 2 },
      ],
      showData: [],
      showData1: [
        { label: "装车总量", value: '0.00' },
        { label: "卸车总量", value: '0.00' },
        { label: "亏吨总量", value: '0.00' },
        { label: "运费总额", value: '0.00' },
        { label: "出车费用总额", value: '0.00' },
        { label: "亏吨金额", value: '0.00' },
      ],
      showData2: [
        { label: "装车总量", value: '0.00' },
        { label: "卸车总量", value: '0.00' },
        { label: "亏吨总量", value: '0.00' },
        { label: "运费总额", value: '0.00' },
        { label: "亏吨金额", value: '0.00' },
      ],
      formInline: {},
      formCtrl: [
        { ...this.ctrls.license },
      ],
      cols: [
        { prop: "license", label: "车牌号", minwidth: 120 },
        { prop: "driver", label: "司机" },
        { prop: "inton", label: "装车重量", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "unton", label: "卸车重量", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "kuiton", label: "亏吨重量", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "freight", label: "运费总额", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "total", label: "出车费用总额", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "kuitotal", label: "亏吨金额", align: 'right', className: 'pr30', minwidth: 120 },
      ],
      ischeck: 1,
      getListUrl: 'statistics',
      baseParams: ['contractid', 'ischeck'],
    };
  },
  methods: {
    tableDataHandler({ data, tongji }) {
      if (data && data.length) {
        this.tableData = [...data]
      }
      if (tongji) {
        const { dtotals,
          freighttotal,
          intontotal,
          kuitontotal,
          kuitotals,
          untontotal } = tongji
        this.showData1[0].value = intontotal
        this.showData2[0].value = intontotal
        this.showData1[1].value = untontotal
        this.showData2[1].value = untontotal
        this.showData1[2].value = kuitontotal
        this.showData2[2].value = kuitontotal
        this.showData1[3].value = freighttotal
        this.showData2[3].value = freighttotal
        this.showData1[4].value = dtotals
        this.showData2[4].value = kuitotals
        this.showData1[5].value = kuitotals
      }
    },
    radioChange(v) {
      this.formInline.ischeck = v
      if (v == 1) {
        this.showData = [...this.showData1]
      } else {
        this.showData = [...this.showData2]
      }
      this.$nextTick(this.getList)
    },
  },
  mounted() {
    this.showData = [...this.showData1]
    const { id } = this.$route.query
    this.formInline = { contractid: id, ischeck: this.ischeck }
    this.$nextTick(this.getList)
    if (this.$route.path.includes('contract')) {
      this.breadcrumb = [
        { name: "合同管理", path: `/contract/list` },
        { name: "合同列表", path: `/contract/list` },
        { name: "数据统计" },
      ]
    }
  }
};
</script>

<style lang="less" scoped>
.dataShow {
  background: #fff;
  padding: 20px;

  .wrap {
    background: rgb(247, 247, 247);
    overflow: hidden;
    border-radius: 5px;
    display: flex;

    .item {
      flex: 1;
      height: 118px;
      overflow: hidden;
      margin: 0px 0px 0px 1%;

      .num {
        height: 25px;
        line-height: 25px;
        text-align: center;
        margin: 23.5px auto 30px;
        font-size: 26px;
        color: rgb(48, 49, 51);
      }

      .text {
        height: 16px;
        line-height: 16px;
        text-align: center;
        font-size: 14px;
        color: rgb(144, 147, 153);
      }

      &:not(:last-of-type) {
        // border-right: 1px solid rgb(230, 230, 230);
        position: relative;

        &::after {
          content: '';
          position: absolute;
          right: 0;
          top: 36px;
          width: 1px;
          height: 46px;
          background: rgb(230, 230, 230);
        }
      }
    }
  }
}
</style>
